module.exports = __webpack_public_path__ + "static/St. Veronica Logo-0bb30d0cd905a1c7a82589fd384abbab.png";